import { useTranslation } from 'react-i18next';

import { LegalTextStyles } from '../legal-text-styles';

const ModalLegal: React.FC<any> = () => {
  const { t } = useTranslation(['legal']);
  return (
    <LegalTextStyles>
      <div className="legal-text">
        <h1>{t('legal:title')}</h1>
        <h2>{t('legal:subtitle-1')}</h2>
        <ul>
          <li>{t('legal:text-1')}</li>
          <li>{t('legal:text-2')}</li>
          <li>{t('legal:text-3')}</li>
          <li>{t('legal:text-4')}</li>
        </ul>
        <h2>{t('legal:subtitle-2')}</h2>
        <ul>
          <li>{t('legal:text-5')}</li>
          <li>{t('legal:text-6')}</li>
          <li>{t('legal:text-7')}</li>
          <li>{t('legal:text-8')}</li>
          <li>{t('legal:text-9')}</li>
          <li>{t('legal:text-10')}</li>
        </ul>
        <h2>{t('legal:subtitle-3')}</h2>
        <ul>
          <li>{t('legal:text-11')}</li>
          <li>{t('legal:text-12')}</li>
          <li>{t('legal:text-13')}</li>
          <li>{t('legal:text-14')}</li>
        </ul>
        <h2>{t('legal:subtitle-4')}</h2>
        <p>{t('legal:text-15')}</p>
        <h2>{t('legal:subtitle-5')}</h2>
        <ul>
          <li>{t('legal:text-16')}</li>
          <li>{t('legal:text-17')}</li>
          <li>{t('legal:text-18')}</li>
          <li>{t('legal:text-19')}</li>
          <li>{t('legal:text-20')}</li>
          <li>{t('legal:text-21')}</li>
          <li>{t('legal:text-22')}</li>
        </ul>
        <h2>{t('legal:subtitle-6')}</h2>
        <ul>
          <li>{t('legal:text-23')}</li>
          <li>{t('legal:text-24')}</li>
          <li>{t('legal:text-25')}</li>
          <li>{t('legal:text-26')}</li>
        </ul>
        <p></p>
      </div>
    </LegalTextStyles>
  );
};

export default ModalLegal;
